import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createPermission } from "../../../redux/Slices/PermissionsSlice";
import { FaArrowRight } from "react-icons/fa";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n/i18n";

const AddPermission = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation("global");
  const isRTL = i18n.language === "ar";
  const textAlign = isRTL ? "right" : "left";
  const dir = isRTL ? "rtl" : "ltr";

  const [formData, setFormData] = useState({
    name: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const result = await dispatch(createPermission(formData));
      if (createPermission.fulfilled.match(result)) {
        toast.success(
          t("permissions.create.success", {
            defaultValue: "تم إنشاء الصلاحية بنجاح",
          }),
          { rtl: isRTL },
        );
        navigate("/permissions");
      } else {
        toast.error(
          result.payload ||
            t("permissions.create.error", {
              defaultValue: "فشل إنشاء الصلاحية",
            }),
          { rtl: isRTL },
        );
      }
    } catch (err) {
      toast.error(
        err.message ||
          t("permissions.create.error", { defaultValue: "فشل إنشاء الصلاحية" }),
        { rtl: isRTL },
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: "30px",
        backgroundColor: "#14263b",
        minHeight: "calc(100vh - 80px)",
        color: "white",
        direction: dir,
        textAlign,
      }}
    >
      <div style={{ marginBottom: "30px" }}>
        <button
          onClick={() => navigate("/permissions")}
          style={{
            backgroundColor: "#666",
            color: "white",
            border: "none",
            padding: "10px",
            borderRadius: "8px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "20px",
            fontSize: "14px",
            flexDirection: isRTL ? "row" : "row-reverse",
          }}
        >
          <FaArrowRight />
          {t("common.back", { defaultValue: "الرجوع" })}
        </button>
        <h1 style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
          {t("permissions.add", { defaultValue: "إضافة صلاحية جديدة" })}
        </h1>
      </div>

      <form
        onSubmit={handleSubmit}
        style={{
          backgroundColor: "#1b3350",
          border: "1px solid #333",
          borderRadius: "12px",
          padding: "32px",
          width: "100%",
          maxWidth: "100%",
        }}
      >
        <div style={{ marginBottom: "20px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "8px",
              fontSize: "14px",
              fontWeight: "bold",
              color: "white",
            }}
          >
            {t("permissions.form.name", { defaultValue: "اسم الصلاحية" })}{" "}
            <span style={{ color: "#dc3545" }}>*</span>
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="e.g., employees.view"
            style={{
              width: "100%",
              padding: "12px",
              backgroundColor: "#1a1f2e",
              border: "1px solid #333",
              borderRadius: "8px",
              color: "white",
              fontSize: "14px",
              boxSizing: "border-box",
              direction: "ltr",
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            gap: "15px",
            justifyContent: "center",
            flexDirection: isRTL ? "row-reverse" : "row",
          }}
        >
          <button
            type="submit"
            disabled={isLoading}
            style={{
              backgroundColor: isLoading ? "#666" : "#AC2000",
              color: "white",
              border: "none",
              padding: "12px 24px",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "bold",
              cursor: isLoading ? "not-allowed" : "pointer",
              opacity: isLoading ? 0.6 : 1,
            }}
          >
            {isLoading
              ? t("common.saving", { defaultValue: "جاري الحفظ..." })
              : t("btns.save", { defaultValue: "حفظ" })}
          </button>
          <button
            type="button"
            onClick={() => navigate("/permissions")}
            style={{
              backgroundColor: "#6c757d",
              color: "white",
              border: "none",
              padding: "12px 24px",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            {t("btns.cancel", { defaultValue: "إلغاء" })}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddPermission;
